import { render } from "./Reward.vue?vue&type=template&id=0863f6d4"
import script from "./Reward.vue?vue&type=script&lang=js"
export * from "./Reward.vue?vue&type=script&lang=js"

import exportComponent from "/Users/YuyiiChiMila/Company/GAME-MAKRO/outlier-p002/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__